export default "__VITE_ASSET__CcMS6IU$__"